let React =       require("react");
const {  Link  } = require('react-router-dom');

let Utilities =           require("../../util/Utilities.js");
let ContentServerClient = require("../../ContentServerClient.js");
let PackageCard =         require("../cards/PackageCard.jsx");
let Model3DCard =         require("../cards/Model3DCard.jsx");
let LibraryCard =         require("../cards/LibraryCard.jsx");
let LoadingPlaceholder =  require("../cards/LoadingPlaceholder.jsx");
let SubNavigationBar =    require("../SubNavigationBar.jsx");
let CircuitsUtil =            require("../../util/CircuitsUtil.js");

let dataTimer = null;

class ExploreOverview extends React.Component {

    constructor() {
        super();

        this.state = {
            modelsError: false,
            packagesError: false,
            librariesError: false,

            modelsLoading: false,
            packagesLoading: false,
            librariesLoading: false,
        };

        this.onSearch = this.onSearch.bind(this);

        this.reloadTimer = null;
        this.requestError = false;

    }

    componentDidMount() {
        const { type } = this.props;
        this.props.onSectionName(type.toLowerCase());
        googleGA("send", "event", type, "pageview");
        document.title = `${type} Overview | library.io`;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.search && nextProps.search !== this.props.search){
            //avoid infinite loop when an error happens
            if(this.requestError === false) this.getContent(nextProps);
        }else{
            if(this.requestError === false) this.getContent(this.props);
        }
    }

    getContent({search = {url: ""}}){
        // user is not concerned with errors fetching here.
        // errors should be on each row or card, not the whole page.
        let handleError = err => console.error(err);

        this.setState({ librariesLoading: true, packagesLoading: true, modelsLoading: true });

        clearTimeout(dataTimer)

        dataTimer = setTimeout(()=>{
          // Each callback has url comparison to not show old results when taking more time to load than newer ones
          ContentServerClient.getFile(handleError, "explore/libraries", `q=${Utilities.escapeSpecialCharacters(search.value)}&${CircuitsUtil.getLibraryQueryFields()}`)
              .then(info => {
                  if (search.url === this.props.search.url) this.setState({libraries: {items: info.results, num: info.numberOfResults}, librariesLoading: false });
              })
              .catch(() =>{ this.requestError = true; this.setState({librariesError: true})});

          ContentServerClient.getFile(handleError, "explore/packages", 'q='+Utilities.escapeSpecialCharacters(search.value))
              .then(info => {
                  if (search.url === this.props.search.url) this.setState({packages: {items: info.results, num: info.numberOfResults}, packagesLoading: false });
              })
              .catch(() =>{ this.requestError = true; this.setState({packagesError: true})});

          ContentServerClient.getFile(handleError, "explore/3dmodels", 'q='+Utilities.escapeSpecialCharacters(search.value))
              .then(info => {
                  if (search.url === this.props.search.url) this.setState({models: {items: info.results, num: info.numberOfResults}, modelsLoading: false });
              })
              .catch(() =>{ this.requestError = true; this.setState({modelsError: true})});
        }, 400)
    }

    componentWillUpdate(nextProps, nextState){
        var data = [];

        if(nextState.libraries) data = data.concat(nextState.libraries.items);
        if(nextState.packages) data = data.concat(nextState.packages.items);
        if(nextState.models) data = data.concat(nextState.models.items);

        if(data.length){
            if(CircuitsUtil.checkMarkForDeleted(data, false)){
                this.setReloadTimer(nextProps);
            }
        }
    }

    setReloadTimer(nextProps){
        clearTimeout(this.reloadTimer);
        this.reloadTimer = setTimeout(()=>{
            this.getContent(nextProps);
        }, 1000);
    }

    onSearch(input){
        this.setState({ search: input.value })
    }

    getName(items, name, errorName, isLoading = false){
        let isExplore = this.props.type === "Explore";

        if(items && !isExplore && !isLoading){
            return `${name} (${items.num})`;
        }else if(items && isExplore){
            return `${name}`;
        }else{
            return  <React.Fragment>
                        {name} <LoadingPlaceholder isError={this.state[errorName]}/>
                    </React.Fragment>
        }
    }

    getShowAll(url){
        if(this.props.type === "Explore" || this.props.type === "Search"){
            if(url == "3dmodels"){
                return <Link className="showAll" to={`/search/${url}`}><button>Search 3D models</button></Link>
            }else{
                return <Link className="showAll" to={`/search/${url}`}><button>Search {url}</button></Link>
            }
        }else{
            return <Link className="showAll" to={`/search/${url}`}><button>Search</button></Link>
        }
    }

    render() {
        let { match, type, handleError } = this.props;

        return (
            <section className="container overview">
                {type !== "Search" &&<SubNavigationBar match={match} search={false}/>}
                    <React.Fragment>
                        <div className="section-title">
                            <h1 className="section-title__title">{this.getName(this.state.libraries, "Libraries", "librariesError", this.state.librariesLoading)}</h1>
                        </div>
                        {this.state.libraries &&
                            <div className="cards -grid -library">
                                {this.state.libraries.items.slice(0, 6)
                                    .map(item => <LibraryCard key={item.id} handleError={handleError} resource={item} isPublicFacing={true} />)}

                                {this.state.libraries.num > 6 && this.getShowAll("libraries")}
                            </div>
                        }
                    </React.Fragment>

                    <div>
                        <div className="section-title">
                            <h1 className="section-title__title">{this.getName(this.state.packages, "Packages", "packagesError", this.state.packagesLoading)}</h1>
                        </div>
                        {this.state.packages &&
                            <div className="cards -grid -package">
                                {this.state.packages.items.slice(0, 6)
                                    .map(item => <PackageCard key={item.id} handleError={handleError} resource = {item} switchThumbnail={true} isPublicFacing={true}/>)}

                                {this.state.packages.num > 6 && this.getShowAll("packages")}
                            </div>
                        }
                    </div>

                    <div>
                        <div className="section-title">
                            <h1 className="section-title__title">{this.getName(this.state.models, "3D Models", "modelsError", this.state.modelsLoading)}</h1>
                        </div>
                        {this.state.models &&
                            <div className="cards -grid -package">
                                {this.state.models.items.slice(0, 6)
                                    .map(item => <Model3DCard key={item.id} handleError={handleError} resource={item} isPublicFacing={true}/>)}

                                {this.state.models.num > 6 && this.getShowAll("3dmodels")}
                            </div>
                        }
                    </div>
            </section>
        );
    }
}

module.exports = ExploreOverview;
